import Vue from 'vue';
import VueRouter from 'vue-router';
import cookieUtils from '@/lib/cookieUtils'
import { AppModule } from '@/store/Auth/AppModule';
import PageNames from '@/router/PageNames';
import PageRoutes from '@/router/PageRoutes';
// Auth Pages
import Login from '@/views/Auth/Login.vue';
import ResetPassword from '@/views/Auth/ResetPassword.vue';
import Sso from '@/views/Auth/Sso.vue';
// Deposit/Lending Accounts Pages
import DepositAccounts from '@/views/Accounts/DepositAccounts.vue';
import DepositAccount from '@/views/Accounts/DepositAccount.vue';
import LendingAccounts from '@/views/Accounts/LendingAccounts.vue';
import LendingAccount from '@/views/Accounts/LendingAccount.vue';
// Customers Pages
import Customers from '@/views/Customers/Customers.vue';
import Customer from '@/views/Customers/Customer.vue';
import Organisations from '@/views/Customers/Organisations.vue';
import Organisation from '@/views/Customers/Organisation.vue';
import People from '@/views/Customers/People.vue';
import Person from '@/views/Customers/Person.vue';
// Dashboard Pages
import Dashboard from '@/views/Dashboard/Dashboard.vue';
// Documentation Pages
import SwaggerCoreApi from '@/views/Documentation/SwaggerCoreApi.vue';
import SwaggerFiCustom from '@/views/Documentation/SwaggerFiCustom.vue';
import SwaggerFiStandard from '@/views/Documentation/SwaggerFiStandard.vue';
import SwaggerUxCustom from '@/views/Documentation/SwaggerUxCustom.vue';
import SwaggerUxStandard from '@/views/Documentation/SwaggerUxStandard.vue';
// Institutional Accounts Pages
import InstitutionAccounts from '@/views/Accounts/InstitutionAccounts.vue';
import InstitutionAccount from '@/views/Accounts/InstitutionAccount.vue';
import ThirdPartyAccounts from '@/views/Accounts/ThirdPartyAccounts.vue';
import ThirdPartyAccount from '@/views/Accounts/ThirdPartyAccount.vue';
// Products Pages
import Products from '@/views/Products/Products.vue';
import Product from '@/views/Products/Product.vue';
import ProductIssues from '@/views/Products/ProductIssues.vue';
import ProductIssue from '@/views/Products/ProductIssue.vue';
import ProductWizardSelector from '@/views/Products/ProductWizardSelector.vue';
import ProductWizard from '@/views/Products/ProductWizard.vue';
import RateSources from '@/views/Products/RateSources.vue';
import RateSource from '@/views/Products/RateSource.vue';
import SubTransactionTypes from '@/views/Products/SubTransactionTypes.vue';
import SubTransactionType from '@/views/Products/SubTransactionType.vue';
import ProductMigrations from '@/views/Products/ProductMigrations.vue';
import ProductMigration from '@/views/Products/ProductMigration.vue';
// Accounting Pages
import Reports from '@/views/Reporting/Reports.vue';
import GeneralLedgerAccounts from '@/views/Accounting/GeneralLedgerAccounts.vue';
import GeneralLedgerAccount from '@/views/Accounting/GeneralLedgerAccount.vue';
import JournalEntries from '@/views/Accounting/JournalEntries.vue';
import JournalEntry from '@/views/Accounting/JournalEntry.vue';
// Settings Pages
import AppMediums from '@/views/Settings/AppMediums.vue';
import AppMedium from '@/views/Settings/AppMedium.vue';
import Roles from '@/views/Settings/Roles.vue';
import Role from '@/views/Settings/Role.vue';
import Users from '@/views/Settings/Users.vue';
import User from '@/views/Settings/User.vue';
import Webhooks from '@/views/Settings/Webhooks.vue';
import Webhook from '@/views/Settings/Webhook.vue';
import Institutions from '@/views/Settings/Institutions.vue';
import Institution from '@/views/Settings/Institution.vue';
import Regions from '@/views/Settings/Regions.vue';
import Region from '@/views/Settings/Region.vue';
// Modules
import { AuthModule } from '@/store/Auth/AuthModule';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountSettingsModule } from '@/store/Accounts/InstitutionAccountSettingsModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import { ProductListModule } from '@/store/Products/ProductListModule';
import { ProductIssueListModule } from '@/store/Products/ProductIssueListModule';
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import { CustomerModule } from '@/store/Customers/CustomerModule';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';
import { PersonModule } from '@/store/Customers/PersonModule';

Vue.use(VueRouter);

const routes = [
    {
        path: PageRoutes.Login,
        name: PageNames.Login,
        meta: { layout: 'logged-out' },
        component: Login,
    },
    {
        path: PageRoutes.ResetPassword,
        name: PageNames.ResetPassword,
        meta: { layout: 'logged-out' },
        component: ResetPassword,
    },
    {
        path: PageRoutes.Sso,
        name: PageNames.Sso,
        meta: { layout: 'logged-out' },
        component: Sso,
    },
    {
        path: PageRoutes.Dashboard,
        name: PageNames.Dashboard,
        meta: { layout: 'logged-in' },
        component: Dashboard,
    },
    {
        path: PageRoutes.ThirdPartyAccounts,
        name: PageNames.ThirdPartyAccounts,
        meta: { layout: 'logged-in' },
        component: ThirdPartyAccounts,
    },
    {
        path: PageRoutes.ThirdPartyAccount,
        name: PageNames.ThirdPartyAccount,
        meta: { layout: 'logged-in' },
        component: ThirdPartyAccount,
    },
    {
        path: PageRoutes.InstitutionAccounts,
        name: PageNames.InstitutionAccounts,
        meta: { layout: 'logged-in' },
        component: InstitutionAccounts,
    },
    {
        path: PageRoutes.InstitutionAccount,
        name: PageNames.InstitutionAccount,
        meta: { layout: 'logged-in' },
        component: InstitutionAccount,
    },
    {
        path: PageRoutes.DepositAccounts,
        name: PageNames.DepositAccounts,
        meta: { layout: 'logged-in' },
        component: DepositAccounts,
    },
    {
        path: PageRoutes.DepositAccount,
        name: PageNames.DepositAccount,
        meta: { layout: 'logged-in' },
        component: DepositAccount,
    },
    {
        path: PageRoutes.LendingAccounts,
        name: PageNames.LendingAccounts,
        meta: { layout: 'logged-in' },
        component: LendingAccounts,
    },
    {
        path: PageRoutes.LendingAccount,
        name: PageNames.LendingAccount,
        meta: { layout: 'logged-in' },
        component: LendingAccount,
    },
    {
        path: PageRoutes.Customers,
        name: PageNames.Customers,
        meta: { layout: 'logged-in' },
        component: Customers,
    },
    {
        path: PageRoutes.Customer,
        name: PageNames.Customer,
        meta: { layout: 'logged-in' },
        component: Customer,
    },
    {
        path: PageRoutes.People,
        name: PageNames.People,
        meta: { layout: 'logged-in' },
        component: People,
    },
    {
        path: PageRoutes.Person,
        name: PageNames.Person,
        meta: { layout: 'logged-in' },
        component: Person,
    },
    {
        path: PageRoutes.Organisations,
        name: PageNames.Organisations,
        meta: { layout: 'logged-in' },
        component: Organisations,
    },
    {
        path: PageRoutes.Organisation,
        name: PageNames.Organisation,
        meta: { layout: 'logged-in' },
        component: Organisation,
    },
    {
        path: PageRoutes.Products,
        name: PageNames.Products,
        meta: { layout: 'logged-in' },
        component: Products,
    },
    {
        path: PageRoutes.Product,
        name: PageNames.Product,
        meta: { layout: 'logged-in' },
        component: Product,
    },
    {
        path: PageRoutes.ProductWizard,
        name: PageNames.ProductWizard,
        meta: { layout: 'logged-in' },
        component: ProductWizard,
    },
    {
        path: PageRoutes.ProductWizardSelector,
        name: PageNames.ProductWizardSelector,
        meta: { layout: 'logged-in' },
        component: ProductWizardSelector,
    },
    {
        path: PageRoutes.ProductIssues,
        name: PageNames.ProductIssues,
        meta: { layout: 'logged-in' },
        component: ProductIssues,
    },
    {
        path: PageRoutes.ProductIssue,
        name: PageNames.ProductIssue,
        meta: { layout: 'logged-in' },
        component: ProductIssue,
    },
    {
        path: PageRoutes.ProductMigrations,
        name: PageNames.ProductMigrations,
        meta: { layout: 'logged-in' },
        component: ProductMigrations,
    },
    {
        path: PageRoutes.ProductMigration,
        name: PageNames.ProductMigration,
        meta: { layout: 'logged-in' },
        component: ProductMigration,
    },
    {
        path: PageRoutes.RateSources,
        name: PageNames.RateSources,
        meta: { layout: 'logged-in' },
        component: RateSources,
    },
    {
        path: PageRoutes.RateSource,
        name: PageNames.RateSource,
        meta: { layout: 'logged-in' },
        component: RateSource,
    },
    {
        path: PageRoutes.SubTransactionTypes,
        name: PageNames.SubTransactionTypes,
        meta: { layout: 'logged-in' },
        component: SubTransactionTypes,
    },
    {
        path: PageRoutes.SubTransactionType,
        name: PageNames.SubTransactionType,
        meta: { layout: 'logged-in' },
        component: SubTransactionType,
    },
    {
        path: PageRoutes.Reports,
        name: PageNames.Reports,
        meta: { layout: 'logged-in' },
        component: Reports,
    },
    {
        path: PageRoutes.GeneralLedgerAccounts,
        name: PageNames.GeneralLedgerAccounts,
        meta: { layout: 'logged-in' },
        component: GeneralLedgerAccounts,
    },
    {
        path: PageRoutes.GeneralLedgerAccount,
        name: PageNames.GeneralLedgerAccount,
        meta: { layout: 'logged-in' },
        component: GeneralLedgerAccount,
    },
    {
        path: PageRoutes.JournalEntries,
        name: PageNames.JournalEntries,
        meta: { layout: 'logged-in' },
        component: JournalEntries,
    },
    {
        path: PageRoutes.JournalEntry,
        name: PageNames.JournalEntry,
        meta: { layout: 'logged-in' },
        component: JournalEntry,
    },
    {
        path: PageRoutes.Users,
        name: PageNames.Users,
        meta: { layout: 'logged-in' },
        component: Users,
    },
    {
        path: PageRoutes.User,
        name: PageNames.User,
        meta: { layout: 'logged-in' },
        component: User,
    },
    {
        path: PageRoutes.Roles,
        name: PageNames.Roles,
        meta: { layout: 'logged-in' },
        component: Roles,
    },
    {
        path: PageRoutes.Role,
        name: PageNames.Role,
        meta: { layout: 'logged-in' },
        component: Role,
    },
    {
        path: PageRoutes.AppMediums,
        name: PageNames.AppMediums,
        meta: { layout: 'logged-in' },
        component: AppMediums,
    },
    {
        path: PageRoutes.AppMedium,
        name: PageNames.AppMedium,
        meta: { layout: 'logged-in' },
        component: AppMedium,
    },
    {
        path: PageRoutes.Webhooks,
        name: PageNames.Webhooks,
        meta: { layout: 'logged-in' },
        component: Webhooks,
    },
    {
        path: PageRoutes.Webhook,
        name: PageNames.Webhook,
        meta: { layout: 'logged-in' },
        component: Webhook,
    },
    {
        path: PageRoutes.Institutions,
        name: PageNames.Institutions,
        meta: { layout: 'logged-in' },
        component: Institutions,
    },
    {
        path: PageRoutes.Institution,
        name: PageNames.Institution,
        meta: { layout: 'logged-in' },
        component: Institution,
    },
    {
        path: PageRoutes.Regions,
        name: PageNames.Regions,
        meta: { layout: 'logged-in' },
        component: Regions,
    },
    {
        path: PageRoutes.Region,
        name: PageNames.Region,
        meta: { layout: 'logged-in' },
        component: Region,
    },
    {
        path: PageRoutes.CoreApiDocumentation,
        name: PageNames.CoreApiDocumentation,
        meta: { layout: 'logged-in' },
        component: SwaggerCoreApi,
    },
    {
        path: PageRoutes.FiDocumentation,
        name: PageNames.FiDocumentation,
        meta: { layout: 'logged-in' },
        component: SwaggerFiStandard,
    },
    {
        path: PageRoutes.FiCustomDocumentation,
        name: PageNames.FiCustomDocumentation,
        meta: { layout: 'logged-in' },
        component: SwaggerFiCustom,
    },
    {
        path: PageRoutes.UxDocumentation,
        name: PageNames.UxDocumentation,
        meta: { layout: 'logged-in' },
        component: SwaggerUxStandard,
    },
    {
        path: PageRoutes.UxCustomDocumentation,
        name: PageNames.UxCustomDocumentation,
        meta: { layout: 'logged-in' },
        component: SwaggerUxCustom,
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {

    // Redirect from old pages to newly pages with the new path
    // This a temporary change to allow old payee links in emails to continue working
    if (to.fullPath.substring(0, 21) === "/third-party-accounts") {
        // Works for /third-party-accounts/:id
        const param = to.fullPath.substring(22);
        if (param) {
            return next({
                path: PageRoutes.ThirdPartyAccount.replace(":id", param)
            });
        }
        // Works for /third-party-accounts
        else {
            return next({
                path: PageRoutes.ThirdPartyAccounts
            });
        }
    }
    if (to.fullPath.substring(0, 23) === "/institutional-accounts") {
        // Works for /institutional-accounts/:id
        const param = to.fullPath.substring(24);
        if (param) {
            return next({
                path: PageRoutes.InstitutionAccount.replace(":id", param)
            });
        }
        // Works for /institutional-accounts
        else {
            return next({
                path: PageRoutes.InstitutionAccounts
            });
        }
    }
    if (to.fullPath.substring(0, 27) === "/accounts/customer-accounts") {
        // Works for /accounts/customer-accounts/:id
        const param = to.fullPath.substring(28);
        if (param) {
            return next({
                path: PageRoutes.DepositAccount.replace(":id", param)
            });
        }
        // Works for /accounts/deposit-accounts
        else {
            return next({
                path: PageRoutes.DepositAccounts
            });
        }
    }

    // This is a catch all conditon where if the page we are routing to cannot be
    // found in the PageRoutes enum, we redirect back to the login page
    // NOTE: This condition will be ignored if there are URL parameters or a query string
    // because we can't accurately match those into the page routes
    const findPageInPageRoutes = Object.values(PageRoutes).find(route => route === to.fullPath);
    const emptyParams = !to.params.id;
    const emptyQueryString = Object.keys(to.query).length === 0;
    if (!findPageInPageRoutes && emptyParams && emptyQueryString) {
        return next({
            path: PageRoutes.Login
        });
    }

    await AppModule.clearErrorMessage();

    if (to.name === PageNames.Login || to.name === PageNames.ResetPassword) {
        AppModule.cleanState();
        AuthModule.cleanState();
        DepositAccountSettingsModule.cleanState();
        ProductDetailsModule.cleanState();
        ProductIssueDetailsModule.cleanState();
        ProductListModule.cleanState();
        ProductIssueListModule.cleanState();
        ProductMigrationModule.cleanState();
        ProductWizardModule.cleanState();
        RateSourceModule.cleanState();
        SubTransactionTypesModule.cleanState();
        InstitutionAccountSettingsModule.cleanState();
        InstitutionAccountModule.cleanState();
        DepositAccountModule.cleanState();
        CustomerModule.cleanState();
        OrganisationModule.cleanState();
        PersonModule.cleanState();
        return next();
    }

    const publicPages = [PageNames.Login.toString(), PageNames.ResetPassword.toString(), PageNames.Sso];
    const authRequired = !publicPages.includes(to.name);
    const loggedIn = cookieUtils.getToken();

    if (authRequired && !loggedIn) {
        if (to.fullPath === "/") {
            return next({
                path: PageRoutes.Login
            });
        }
        else {
            return next({
                path: PageRoutes.Login,
                query: { redirect: to.fullPath }  // Store the full path to redirect the user to after login
            });
        }
    }
    else {
        if (to.path === "/") {
            return next({
                path: PageRoutes.Login
            })
        }
        return next();
    }

});

export default router